const styles = theme => ({
  paddingBottom: {
    paddingBottom: '100px',
  },
  container: {
    maxWidth: '1280px',
    margin: 'auto',
    // padding: '16px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
    },
  },
  containerWhenSidebarHidden: {
    padding: '0px',
  },
  mobileTitleHead: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '20px',
    borderBottom: '3px solid #EBEEF3',
    '& h2': {
      fontSize: '16px',
      fontWeight: 500,
    },
  },
  footerBtn: {
    '& img': {
      margin: '0 8px',
    },
  },
  rightContainer: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0px !important',
    },
  },
  rightContainerWhenSidebarHidden: {
    marginTop: '24px',
  },
  footer: {
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    background: '#fff',
    padding: '16px',
    borderTop: '3px solid #EBEEF3',
    zIndex: '1',
    '& $footerContainer': {
      // maxWidth: '1184px',
      display: 'flex',
      padding: '0px',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        padding: '0',
      },
    },
  },
  footerContainer: {},
  '@media (max-width: 599.95px)': {
    footer: {
      bottom: '68px',
    },
  },
  disclaimer: {
    width: '100%',
    marginBottom: '8px',
  },
  rotateArrow: {
    '& img': {
      marginRight: '8px',
      transform: 'rotate(180deg)',
    },
  },
});

export default styles;
